import type { FilteredView } from '../types';
import {
  articlesQueries,
  emailsQueries,
  epubsQueries,
  pdfsQueries,
  tweetsQueries,
  videosQueries,
} from './filteredViews';

// Canonical order for default category views. Custom views (domain:/tag:) are
// absent here and sort by their manual `order` field instead.
export const desireViewsIdsOrder = [
  ...articlesQueries,
  ...epubsQueries,
  ...emailsQueries,
  ...pdfsQueries,
  ...tweetsQueries,
  ...videosQueries,
];

// Missing/null/Infinity orders all map to Infinity (sort last). Must be a finite
// number to count as a real position.
const orderValue = (view: FilteredView): number =>
  typeof view.order === 'number' && Number.isFinite(view.order) ? view.order : Infinity;

// Default views keep their canonical order and precede custom views; custom views
// sort by manual `order`. Must be antisymmetric (return 0 on ties) so the sort is
// stable — the old comparator wasn't, which let reordered domain views drop.
export const sortViews = (a: FilteredView, b: FilteredView): number => {
  const indexA = desireViewsIdsOrder.indexOf(a.query);
  const indexB = desireViewsIdsOrder.indexOf(b.query);
  const aIsDefault = indexA > -1;
  const bIsDefault = indexB > -1;

  if (aIsDefault && bIsDefault) {
    return indexA - indexB;
  }
  if (aIsDefault) {
    return -1;
  }
  if (bIsDefault) {
    return 1;
  }

  const orderA = orderValue(a);
  const orderB = orderValue(b);
  if (orderA === orderB) {
    return 0;
  }
  return orderA < orderB ? -1 : 1;
};
